import { updateTimeStreamProject } from 'owa-timestream-store';
import {
    closeBoardEditorDialog,
    isEditingProject,
    getName,
    getProjectId,
    setLoadState,
    BoardEditorLoadState,
} from '../viewstate';
import { lazyCreateProject } from 'owa-calendar-board-welcome';

export async function createOrUpdateBoardName() {
    setLoadState(BoardEditorLoadState.Saving);
    try {
        const projectUpdates = { name: getName() };
        await (isEditingProject()
            ? updateTimeStreamProject(getProjectId()!, projectUpdates)
            : lazyCreateProject.importAndExecute({ outlookSpace: projectUpdates }));

        closeBoardEditorDialog();
    } catch (e) {
        setLoadState(BoardEditorLoadState.Error);
    }
}
